import { PATH_NAME_HOME, PATH_NAME_PROMOTION_USER } from '@/common/router.const'
import _ from 'lodash'
import utils from '@/common/util/utils'
import { MyPooqService, postPromotionUser } from '@/common/api/api.service'
import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'

export default [
  {
    path: '/promotion/user/:promotionid',
    name: PATH_NAME_PROMOTION_USER,
    alias: '/promotion/user.html',
    components: {
      homeLayout: () => import(/* webpackChunkName: "promotion_user" */'@/views/promotion/user')
    },
    beforeEnter: (to, from, next) => {
      const goHome = () => {
        const device = utils.cookies.getDevice()
        if (device === DEVICE_TYPE_ANDROID) {
          window.Android.ClosePopupAndReload()
        } else {
          next({ name: PATH_NAME_HOME })
        }
      }
      const promotionId = _.defaultTo(_.get(to, 'params.promotionid', ''), '')
      if (promotionId === '' || utils.cookies.getCredential() === 'none') { goHome() }
      MyPooqService.purchaseProduct({
        startdate: '',
        enddate: '',
        producttype: 'pass',
        autopayment: 'n',
        offset: 0,
        limit: 10,
        orderby: 'new'
      }).then((response) => {
        const unsubscribeVoucherList = _.get(response, ['data', 'list'], []).filter(voucher => voucher.autopayment === 'true' && voucher.autopaymentstatus === 'n')
        const hasOneUnSubscribeVoucher = unsubscribeVoucherList.length === 1
        const serviceId = _.get(unsubscribeVoucherList, ['0', 'userserviceid'], '')
        if (hasOneUnSubscribeVoucher) {
          postPromotionUser({
            promotionId: promotionId,
            productType: 'pass',
            keyId: serviceId
          }).then((response) => {
            const resultCode = _.defaultTo(_.get(response, 'data.resultcode', null), '')
            if (resultCode === '200' || resultCode === 200) {
              next()
            } else {
              utils.alert(_.defaultTo(_.get(response, 'response.data.resultmessage', null), '정상 처리되지 않았습니다\n나중에 다시 시도해주세요.'), goHome)
            }
          }).catch((error) => {
            utils.alert(_.defaultTo(_.get(error, 'response.data.resultmessage', null), '정상 처리되지 않았습니다\n나중에 다시 시도해주세요.'), goHome)
          })
        } else {
          utils.alert('참여 대상자가 아니시네요.', goHome)
        }
      })
        .catch((error) => {
          const resultCode = _.defaultTo(_.get(error, 'response.data.resultcode', ''), '')
          if (resultCode === '550' || resultCode === '551') {
            utils.alert(_.defaultTo(_.get(error, 'response.data.resultmessage', ''), '정상 처리되지 않았습니다\n나중에 다시 시도해주세요.'), goHome)
          }
        })
    }
  }
]
